export const feedbackFormConstants = {
  minLengthForSimilarNames: 10
};
